import RouteProtection from "../common/RouteProtection";
import Header from "../common/Header";
import PageContainer from "../common/PageContainer";
import SearchBar from "../common/SearchBar";
import NewItemButton from "../common/NewItemButton";
import MessageList from "./MessageList";
import MessagePopUp from "./MessagePopUp";

import { useEffect, useState } from "react";
import { fetchWithToken } from "../../functions/fetch";
import { useUpdateMessage } from "../../contexts/updateMessageContext";
import { sortByTime } from "../../functions/array";
import { getReceiverText } from "../../functions/message";
import { isoToFormatDate } from "../../functions/formatTime";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import color from "../../config/color";
import TemplateMessagePage from "./TemplateMessagePage/TemplateMessagePage";

const MessagePage = () => {
  const [messages, setMessages] = useState([]);
  const [filteredMessages, setFilteredMessages] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [firstRender, setFirstRender] = useState(true);

  const { updateMessage, setUpdateMessage } = useUpdateMessage();

  // refetch messages every time because populating user's info is required
  const fetchMessage = async () => {
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/message`,
    );
    if (res.status === 200) {
      const newMessages = res.messages;
      // This field is for searching

      newMessages.forEach((message) => {
        const searchedTexts = [
          getReceiverText(message),
          isoToFormatDate(message.createdAt, "yyyy/MM/dd HH:mm"),
          message.text,
        ];

        message.searchField = searchedTexts.join(" ");
      });

      setMessages(sortByTime(res.messages, "createdAt"));
      setFilteredMessages(res.messages);
    } else {
      console.error(res);
    }
  };

  useEffect(() => {
    if (updateMessage || firstRender) {
      fetchMessage();
      setUpdateMessage(false);
      setFirstRender(false);
    }
  }, [updateMessage]);

  return (
    <>
      <RouteProtection />
      <Header />
      <PageContainer>
        <Tabs pt={8}>
          <TabList pl={12} gap={4}>
            <Tab
              px={5}
              border={`1px solid ${color.borderGray}`}
              color={color.gray}
              bgColor={color.borderGray}
              _selected={{
                color: color.gray,
                bgColor: "white",
                border: `2px solid ${color.borderGray}`,
              }}
            >
              訊息管理
            </Tab>
            <Tab
              px={5}
              border={`1px solid ${color.borderGray}`}
              color={color.gray}
              bgColor={color.borderGray}
              _selected={{
                color: color.gray,
                bgColor: "white",
                border: `2px solid ${color.borderGray}`,
              }}
            >
              公版訊息管理
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              {showPopUp ? <MessagePopUp setShowPopUp={setShowPopUp} /> : <></>}
              <div className="flex justify-between items-center">
                <NewItemButton itemName="訊息" setShowPopUp={setShowPopUp} />
                <SearchBar items={messages} setFunction={setFilteredMessages} />
              </div>
              <MessageList messages={filteredMessages} />
            </TabPanel>
            <TabPanel>
              <TemplateMessagePage />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </PageContainer>
    </>
  );
};

export default MessagePage;
